<template>
  <div class="my-4 md:mx-8">
    <div class="flex w-full items-center">
      <v-icon 
      color="primary" 
      class="text-6xl ic-management-mobile-phone" />
      <div class="uppercase font-bold text-grey text-base">
        {{ $t('messages.transfers.confirm_transfer') }}
      </div>
    </div>
    <div class="">
      <div class="bg-white rounded-lg elevation-0 p-4">
        <!-- Debit Account -->
        <div>
          <v-subheader 
          :class="`${colors.textPrimary}`" 
          class="uppercase text-md font-bold p-0"
          >
            {{ $t('messages.transfers.detail') }}
          </v-subheader>

          <div class="flex flex-col w-full text-grey md:8">
            <label 
            class="first-case text-grey text-md font-medium md:text-lg"
            >
              {{ $t('messages.transfers.reference_number') }}
            </label>
            <div 
            class="flex-1 mx-1 break-words">
              {{ reference_id }}
            </div>
          </div>
          <div class="flex flex-col w-full text-grey md:w-1/2">
            <label 
            class="first-case text-grey text-md font-medium md:text-lg"
            >
              {{ $t('messages.common.time.date') }}
            </label>
            <div 
            class="flex-1 mx-1 break-words">
              {{ value_date }}
            </div>
          </div>
          <div class="flex flex-col w-full text-grey md:w-1/2">
            <label 
            class="first-case text-grey text-md font-medium md:text-lg"
            >
              {{ $t('messages.common.country') }}
            </label>
            <div 
            class="flex-1 mx-1 break-words">
              {{ country }}
            </div>
          </div>
          <div class="flex flex-col w-full text-grey md:w-1/2">
            <label 
            class="first-case text-grey text-md font-medium md:text-lg"
            >
              {{ $t('messages.common.identification_ordering') }}
            </label>
            <div 
            class="flex-1 mx-1 break-words">
              {{ ordering_name === '' ? '-' : ordering_name }}
            </div>
          </div>
          <div class="flex flex-col w-full text-grey md:w-1/2">
            <label 
            class="first-case text-grey text-md font-medium md:text-lg"
            >
              {{ $t('messages.amounts.amount') }}
            </label>
            <div 
            class="flex-1 mx-1 break-words">
              {{ amount }}
            </div>
          </div>
          <div class="flex flex-col w-full text-grey md:w-1/2">
            <label 
            class="first-case text-grey text-md font-medium md:text-lg"
            >
              {{ $t('messages.common.currency') }}
            </label>
            <div 
            class="flex-1 mx-1 break-words">
              {{ currency }}
            </div>
          </div>
        </div>
        <!-- ./ Debit Account -->

        <!-- Declare Income -->
        <div>
          <div class="flex flex-wrap">
            <!-- EXPENSES -->
            <div class="flex justify-center md:justify-start flex-wrap w-full my-4 p-1 md:w-1/2" v-if="requireConcepts">
              <div 
              :class="`${colors.textPrimary}`" 
              class="uppercase text-md font-bold mb-3 w-full"
              >
                Declaración de ingresos
              </div>
              <div class="w-full">
                <div 
                class="py-4 rounded-lg text-center relative" 
                :class="{
                  'border-dotted border-grey-lighter' :form.concepts.selectedItems.length === 0,
                  'bg-grey-light' :form.concepts.selectedItems.length > 0,
                }">
                  <template v-if="!form.concepts.selectedItems.length">
                    Agregar concepto para transferencias mayores o iguales a $5,000.00
                  </template>
                  <template v-else>
                    <div 
                    @click="removeConcept"
                      class="absolute rounded-full -mt-1 cursor-pointer hover:bg-red-dark pin-t pin-r h-4 w-4 p-3 bg-red text-white text-center justify-center items-center flex">
                      X
                    </div>
                    {{ form.concepts.selectedItems[0].name }}
                  </template>
                </div>
                <span class="text-red-light text-sm" v-if="requireConceptMessage">{{ requireConceptMessage }} </span>
              </div>

              <v-btn 
              :loading="list_expense_statement.length === 0" 
              :color="`${colors.secondaryColor}`" 
              outline
                class="elevation-0 rounded-xl font-bold" 
                @click="form.concepts.dialog = true"
                >{{ $t("messages.common.actions.add") }}
              </v-btn>
              <template v-if="list_expense_statement.length > 0">
                <dynamic-menu 
                :header="form.concepts.header" 
                :items="list_expense_statement"
                  :dialog="form.concepts.dialog" 
                  :returned-item="form.concepts.item" 
                  @closeMe="closeDialogConcept"
                  @chosenItem="addConcept" 
                  />
              </template>
            </div>
            <!-- Upload Files -->
            <div class="w-full md:w-1/2 my-4 p-1" v-if="require_documents">
              <div class="flex-col first-case items-right">
                <div 
                :class="`${colors.textPrimary}`" 
                class="uppercase text-md font-bold w-full"
                >
                  Documentos adjuntos
                </div>
                <label class="text-grey text-xs md:text-sm font-normal first-case">
                  ( {{ $t("messages.info_msgs.maximum_file_size", { size: maxFileSize }) }} )
                </label>
                <input 
                v-model="form.fileInfo.fileName" 
                :loading="loadingStep"
                  :data-vv-as="$t('messages.common.attached_docs')" 
                  data-vv-scope="step-two"
                  data-vv-name="step-two.file" 
                  class="hidden">
                <div class="flex border-red-dark border w-full mt-1">
                  <div 
                  :loading="loadingStep" 
                  :class="{'h-20': (files.length === 0)}"
                    class="border border-grey border-solid w-full">

                    <span 
                    v-for="(file, index) in files" 
                    :key="index"
                      class="inline-flex m-1 px-2 rounded-full bg-grey-light items-center"
                      :class="{'primary': !file.isValid}">
                      <div class="mr-2">{{ file.name }}</div>
                      <div @click="removeFile(file)" class="cursor-pointer flex justify-center items-center w-6 rounded-full bg-red-dark text-white">X</div>
                    </span>
                  </div>
                  <!-- <div class="flex flex-col w-full sm:flex-row mt-1">
                  </div> -->
                  <input 
                  id="filesToUpload" 
                  ref="filesToUpload" 
                  :accept="accept" 
                  :loading="loadingStep" 
                  type="file"
                    class="hidden" 
                    multiple 
                    @change="handleFileChange">
                  <v-btn 
                  :loading="loadingStep" 
                  :color="`${colors.secondaryColor}`" 
                  outline
                    class="elevation-0 rounded-xl font-bold" 
                    @click="handleUploadBtnClick">{{ $t("messages.common.actions.select") }}</v-btn>
                </div>
              </div>
            </div>
            <div class="w-full md:pr-3 sm:w-1/6 lg:w-1/6">
              <br>
            </div>
            <!-- Description -->
            <div class="w-full md:pr-3">
              <div class="flex flex-col">
                <label 
                class="first-case text-grey text-md font-medium md:text-lg"
                >
                  {{ $t('messages.common.description') }}
                </label>
                <v-textarea 
                v-validate="'required'" 
                :color="`${colors.secondaryColor}`"
                  :error-messages="errors.collect('reason')" 
                  :data-vv-as="$t('messages.common.description')"
                  v-model.lazy="form.reason" 
                  data-vv-name="reason" 
                  class="poppins py-0 text-md md:text-lg" 
                  type="text"
                  required 
                  />
              </div>
            </div>
            <div 
            v-if="action === 'UNLINK'" 
            class="w-full md:pr-4 md:w-1/2">
              <br>
            </div>
          </div>
        </div>
        <!-- ./ Mobile Phone To Link -->

      </div>
      <div class="flex flex-col-reverse justify-end mt-3 -mr-1 sm:flex-row"
      >
        <v-flex class="flex-col flex-col-reverse sm:flex-row justify-end">
          <v-btn 
          :disabled="executing" 
          :to="{ name: 'declare_income' }"
            class="elevation-0 bg-grey text-white rounded-xl font-bold">{{ $t("messages.common.actions.back") }}</v-btn>
          <v-btn 
          :disabled="executing"
          :loading="executing" 
          :class="colors.primaryBackground"
            class="elevation-0 text-white rounded-xl font-bold" 
            @click="checkFilesToUpload()">
            {{ this.$i18n.t("messages.common.actions.accept") }}
          </v-btn>
        </v-flex>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import { remove } from 'lodash';
const PhoneNumberInput = () => import('@/components/PhoneNumberInput');

export default {
  name: 'DeclareIncomeFormSinpe',
  components: {
    PhoneNumberInput
  },
  props: {
    account_num: {
      type: String,
      default: '',
      required: true
    },
    // reference_id
    amount: {
      type: Number,
      default: 0,
      required: true
    },
    action: {
      type: String,
      default: 'LINK',
      required: true
    },
    reference_id: {
      type: Number,
      required: true
    },
    value_date: {
      type: String,
      default: ''
    },
    country: {
      type: String,
      default: ''
    },
    ordering_name: {
      type: String,
      default: ''
    },
    currency: {
      type: String,
      default: ''
    },
    list_expense_statement: {
      type: Array,
      default: []
    },
    customer_contract_relation_id: {
      type: Number,
      required: true
    },
    country_id: {
      type: Number,
      required: true
    },
    require_documents: {
      type: Boolean,
      default: false
    },
    is_document_Upload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        order: {},
        incomeStatement: null,
        reason: null,
        fileInfo: {
          fileName: null,
          files: []
        },
        concepts: {
          valid: true,
          slots: 1,
          item: null,
          header: {
            name: this.$i18n.t("messages.transfers.concepts"),
            parent_id: null,
          },
          selectedItems: [],
          dialog: false,
        },
        Is_Add_Document: false,
      },
      files: [],
      executing: false,
      filesNotUploadCount: 0,
      accept: '.xlsx, .xls, .docx, .pdf, .png, .jpeg',
      yesNoDialog: false,
      processing: false,
      loadingStep: false,
      linkPhoneNumberDialog: false,
      phoneNumberToSend: "",
      phoneNumberLength: 8,
      sharedKey: null,
      disabledVerificationButton: false,
      requireConceptMessage: null
    };
  },
  computed: {
    ...mapGetters({
      colors: 'currentColors',
      menuChilds: "general/menuChilds",
      countries: "general/regionalCountries",
    }),
    ...mapState({
      dialog: (state) => state.dialog,
      // countries: (state) => state.general.countries,
      maxFileSize: state => state.general.menu.max_file_size,
      verificationToken: (state) => state.orders.verificationToken,
      orderRequest: (state) => state.orders.orderRequest,
      orderInfo: (state) => state.orders.orderInfo
    }),
    currentMenu() {
      return this.menuChilds.find(m => m.name === this.$route.name);
    },
    requireConcepts() {
      return this.amount >= 5000
    }
  },
  beforeDestroy() {
    this.resetOrderState();
    this.requireConceptMessage = null
  },
  beforeMount() {
    this.requireConcept();
  },
  methods: {
    ...mapActions({
      updateIncomingRegionalSINPE: 'transactions/DeclareTransferRegionalSINPE',
      uploadOrderFiles: 'orders/uploadOrderFiles',
      getCountries: 'general/getRegionalCountries',
      isAttachDocumentRequiredForClient: 'general/isAttachDocumentRequiredForClient'
    }),
    ...mapMutations({
      setOrderRequest: 'orders/SET_ORDER_REQUEST',
      resetOrderState: 'orders/RESET_ORDER_STATE'
    }),
    handleUploadBtnClick() {
      // this.clearFileData();
      this.$refs.filesToUpload.click();
    },
    handleFileChange(e) {
      for (const key in e.target.files) {
        const element = e.target.files[key];
        if (element.size) {
          if (element.size / 1000000 < this.maxFileSize) {
            this.files.push({
              name: element.name,
              isValid: true
            });
            this.form.fileInfo.files.push(element);
          } else {
            this.files.push({
              name: element.name,
              isValid: false
            });
            this.filesNotUploadCount++;
          }
        }
      }
      this.form.fileInfo.fileName = '';
      this.form.fileInfo.files.forEach(
        f => (this.form.fileInfo.fileName += f.name + ';')
      );
    },
    async checkFilesToUpload() {
      if (this.require_documents && this.filesNotUploadCount > 0) {
        this.$store.dispatch(
          'dialog',
          {
            message: this.$i18n.t('messages.transfers.warningFilesToUpload', {
              size: this.maxFileSize
            }),
            type: 'warning'
          },
          { root: true }
        );
      } else {
        await this.executeProcess();
      }
    },
    removeFile(file) {
      if (!file.isValid) this.filesNotUploadCount--;
      remove(this.form.fileInfo.files, f => f.name === file.name);
      remove(this.files, f => f.name === file.name);
      this.files = [...this.files];

      this.form.fileInfo.fileName = '';
      this.form.fileInfo.files.forEach(
        f => (this.form.fileInfo.fileName += f.name + ';')
      );
    },
    async executeProcess(){
      this.$store.dispatch('auth/resetUIInterval');
      try{
        this.executing = true;
        let valid = await this.$validator.validateAll();
        console.log(this.require_documents , this.form.fileInfo.files.length === 0);
        if (this.require_documents && this.form.fileInfo.files.length === 0) {
          this.showMessageValidationForAttachedDoc();
          return;
        }

        if (this.requireConcept() && this.form.concepts.selectedItems.length == 0) {
          this.requireConceptMessage = this.$i18n.t("messages.transfers.sinpe_require_concept_income")
          return;
        } else {
          this.requireConceptMessage = null;
        }

        if (valid) {

          if (this.form.fileInfo.files.length > 0) {
            this.form.Is_Add_Document = true;
          }

          await this.setOrderIncomingRegionalSINPERequest();
          await this.updateIncomingRegionalSINPE(this.orderRequest);

          if (this.form.fileInfo.files.length > 0) {
            await this.uploadOrderFiles({
              orderId: this.orderInfo.order_id,
              orderType: 'incoming_regional_sipa',
              referenceId: this.customer_contract_relation_id,
              confirmationId: this.orderInfo.confirmation_id,
              all_docs: 1,
              files: this.form.fileInfo.files
            });
          }

          // window.console.log(this.orderInfo.confirmation_id);
          if (this.orderInfo.confirmation_id > 0) {
            this.$store.dispatch('dialog',
              {
                title: 'Operación exitosa',
                message: 'El registro de transferencia entrante ha sido actualizada.',
                type: 'sucess'
              },
              { root: this.$router.push("declare-income") }
            );

          } else{
            this.$store.dispatch('dialog',
              {
                title: 'Operación fallida',
                message: 'La declaración de ingresos no ha podido procesarse',
                type: 'error'
              },
              { root: true }
            );
          }
        }
        this.$vuetify.goTo('#app', { duration: 1000 });
        this.executing = false;
      } catch (error) {
        this.$store.dispatch(
          'dialog',
          {
            title: 'Operación fallida',
            message: error,
            type: 'error'
          },
          { root: true }
        );
      } finally {
        this.executing = false;
      }
    },
    async setOrderIncomingRegionalSINPERequest() {
      this.setOrderRequest({
        verification_token: this.verificationToken,
        customer_contract_relation_id: this.customer_contract_relation_id,
        bp_id: this.reference_id,
        amount: this.amount,
        description: this.form.reason,
        income_statement_id: this.form.concepts.selectedItems.length > 0 ? this.form.concepts.selectedItems[0].id : null,
        is_document_Upload: this.form.Is_Add_Document,
        send_to: 'incoming_regional_sinpe'
      });
    },
    showMessageValidationForAttachedDoc(){
      this.$store.dispatch(
        'dialog',
        {
          title: 'Validación de documentos',
          message: 'Para poder proceder con la transferencia debe adjuntar documentos de respaldo en el campo Documentos Adjuntos',
          type: 'error'
        },
        { root: true }
      );
    },
    addConcept(value) {
      const { id, name, code, parent_id, hasSubitems, index } = value;
      const item = {
        id,
        name,
        parent_id,
        code,
        index,
        hasSubitems,
        amount: 0.0,
      };
      this.form.concepts.selectedItems.push(item);
      this.form.concepts.slots--;
    },
    removeConcept() {
      this.form.concepts.selectedItems = [];
      this.form.concepts.slots++;
    },
    requireConcept() {
      const requireConcepts = this.amount >= 5000 && this.form.concepts.selectedItems.length === 0;

      return requireConcepts;
    },
    closeDialogConcept() {
      this.form.concepts.dialog = !this.form.concepts.dialog;
    },
  }
};
</script>

<style></style>
